import React, { useEffect } from "react";
import { enableForEnv, Stages } from "~/lib/utils";

export const enableAmplitudeSessionReplay = () =>
  enableForEnv([Stages.PRODUCTION, Stages.STAGING]);

const AmplitudeSessionReplay: React.FC = () => {
  useEffect(() => {
    const sessionReplayScript = document.createElement("script");
    sessionReplayScript.src =
      "https://cdn.amplitude.com/libs/plugin-session-replay-browser-1.8.0-min.js.gz";
    sessionReplayScript.async = true;

    Promise.all([
      new Promise((resolve) => (sessionReplayScript.onload = resolve)),
    ]).then(() => {
      const initScript = document.createElement("script");
      initScript.innerHTML = `
        window.amplitude.add(window.sessionReplay.plugin({sampleRate: 1}));
      `;
      document.head.appendChild(initScript);
    });

    return () => {
      document.head.removeChild(sessionReplayScript);
    };
  }, []);

  return null;
};

export default AmplitudeSessionReplay;
